import { useMutation, useQueryClient } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { PutPatientTreatmentScheduleActivityArgs } from "../schemas/Treatment";

import { queryKeyPrefix } from "./useGetPatientTreatmentScheduleWeek";

export const usePutPatientTreatmentScheduleActivity = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<void, Error, PutPatientTreatmentScheduleActivityArgs>({
    mutationFn: args => client.putPatientTreatmentScheduleActivity(args),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyPrefix);
    },
  });
};
